/**
 * Fixed UI copy of the reviews (Figma 60137:5689, 60137:9455, 60152:14462, 60152:14768). It is not
 * administration content and the core dictionary has no matching string (its wording is „recenzia“),
 * so it is kept here in one block until the dictionary gets these keys.
 */
export const REVIEW_COPY = {
  preview: {
    title: 'Hodnotenia zákazníkov',
    all: 'Všetky hodnotenia',
    next: 'Ďalšie hodnotenia',
  },
  tab: {
    title: 'Hodnotenia',
    write: 'Napísať hodnotenie',
    filters: 'Filtrovať hodnotenia',
    all: 'Všetky',
    withPhoto: 'S fotkou',
    sortBy: 'Zoradiť:',
    showMore: 'Zobraziť ďalšie hodnotenia',
    loadFailed: 'Hodnotenia sa nepodarilo načítať.',
    retry: 'Skúsiť znova',
    anonymous: 'Zákazník',
  },
  sort: {
    newest: 'Najnovšie',
    best: 'Najlepšie',
    worst: 'Najhoršie',
  },
  count: { one: 'hodnotenie', few: 'hodnotenia', other: 'hodnotení' },
  summary: {
    distribution: 'Rozdelenie hodnotení podľa hviezdičiek',
    rating: (value: string) => `Hodnotenie ${value} z 5`,
  },
  signIn: {
    title: 'Hodnotiť môžu len prihlásení zákazníci',
    text: 'Prihláste sa do svojho účtu a podeľte sa o skúsenosť s produktom.',
    action: 'Prihlásiť sa a hodnotiť',
  },
  form: {
    title: 'Napísať hodnotenie',
    rating: 'Celkové hodnotenie',
    ratingHint: 'Zadajte počet hviezdičiek.',
    ratingLabels: ['Veľmi zlé', 'Zlé', 'Priemerné', 'Veľmi dobré', 'Výborné'],
    experience: 'Vaše skúsenosti',
    experiencePlaceholder: 'Popíšte vašu skúsenosť',
    note: 'Hodnotenie zverejníme po kontrole, zvyčajne do 24 hodín. Odoslaním súhlasíte s pravidlami hodnotenia.',
    submit: 'Odoslať hodnotenie',
  },
  added: {
    title: 'Hodnotenie pridané',
    text: 'Vaše hodnotenie bolo odoslané na schválenie administrátorom. Informáciu o prijatí hodnotenia dostanete e-mailom.',
    close: 'Pokračovať na stránku',
  },
} as const;

/** Longest review text the API accepts in the form (Figma counter „n / 1 000“). */
export const REVIEW_MAX_LENGTH = 1000;
